import { useContext } from 'react';
import { LogOutContext } from '../context';

export function useShouldLogOut() {
	return useContext(LogOutContext);
}
